import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import moment from 'moment';
import { injectIntl } from 'react-intl';

import messages from 'aurora-translations';
import ADGMImage from '../../../ADGMImage';
import ADGMTextField from '../../../ADGMTextField';
import ADGMDatePicker from '../../../ADGMDatePicker';
import styles from './styles';

function DateField(props) {
  const { classes, value, label, intl, onChange, disabled, ...fieldProps } = props;
  const date = useMemo(() => (value ? moment(value).format('DD/MM/YYYY') : ''), [value]);

  return (
    <ADGMDatePicker
      date={date}
      onChange={onChange}
      disabled={disabled}
      component={
        <ADGMTextField
          value={date}
          autoComplete='off'
          startAdornment={<ADGMImage name='Calendar.svg' alt='calendar' className={classes.calendarFieldIcon} />}
          disabled={disabled}
          label={messages[label]?.id ? intl.formatMessage({ ...messages[label] }) : label}
          {...fieldProps}
        />
      }
    />
  );
}

DateField.propTypes = {
  classes: PropTypes.object.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  intl: PropTypes.object.isRequired,
  label: PropTypes.string,
};

DateField.defaultProps = {
  value: '',
  onChange: null,
  disabled: false,
  label: '',
};

export default withStyles(styles)(injectIntl(DateField));
